module.exports = __webpack_public_path__ + "static/media/6.3_preview.cf22669a.png";